import { createAction, props } from '@ngrx/store';
import { ActionPayload } from "@hrra/core";

export enum Actions {
    LoadIndustries = '[Industry picker] load industries',
    ToggleExpandHeadIndustry = '[Industry picker] toggle expand head industry',
    SelectIndustry = '[Industry picker] select industry',
    UnselectIndustry = '[Industry picker] unselect industry',
    FilterIndustry = '[Industry picker] filter industries',
    ResetIndustryFilter = '[Industry picker] reset Industry filter'
}

export const loadIndustries = createAction(
    Actions.LoadIndustries,
    props<ActionPayload<{ industryIds: string[] }>>()
);

export const toggleExpandHeadIndustry = createAction(
    Actions.ToggleExpandHeadIndustry,
    props<ActionPayload<{ industryId: string }>>()
);

export const selectIndustry = createAction(
    Actions.SelectIndustry,
    props<ActionPayload<{ industryId: string}>>()
);

export const unselectIndustry = createAction(
    Actions.UnselectIndustry,
    props<ActionPayload<{ industryId: string}>>()
);

export const filterIndustries = createAction(
    Actions.FilterIndustry,
    props<ActionPayload<{ query: string }>>()
);

export const resetIndustryFilter = createAction(
    Actions.ResetIndustryFilter
);